import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import Title from '../ui/title'
import Content from '../ui/content'

const Support = (props) => {

  const { translate } = props

  return (
    <div>
      <Title title={translate("general_support")} />
      <Content translate={translate}>
        hello
      </Content>
    </div>
  )
}

export default withStyles(styles)(Support)



// WEBPACK FOOTER //
// ./src/components/support/index.js